<template>
    <div class="versicherungs-button" role="button" tabindex="0" @click="$emit('select')" @keydown.enter="$emit('select')" @keydown.space.prevent="$emit('select')">
        <input type="checkbox" id="auslandsversicherung" class="d-none" :checked="selected">
        <label 
            class="d-flex flex-column p-3 border rounded w-100" 
            data-type="auslandsversicherung"
            :class="{ 'selected': selected }"
        >
            <div class="d-flex justify-content-between align-items-center">
                <span class="">
                    <auslandsversicherung_icon></auslandsversicherung_icon>
                </span>
                <h1>{{ beitragStr }}</h1>
            </div>
            <h3 class="mt-2">Ausland</h3>
        </label>
    </div>
</template>

<script setup>
import auslandsversicherung_icon from '@/components/icons/auslandsversicherung_icon.vue';

defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    beitragStr: {
        type: String,
        default: 'ab 11,40 €'
    }
});

defineEmits(['select']);
</script>

<style scoped>
/* Fallback für selected State, falls CSS-Reihenfolge Probleme macht */
label.selected {
    background-color: var(--vigo-1-500-bg) !important;
}

label.selected h1,
label.selected h3 {
    color: var(--vigo-hell-text) !important;
}

label.selected :deep(svg path) {
    fill: var(--vigo-hell-bg) !important;
}
</style>
